export default __webpack_public_path__ + "static/media/result-error.f0af6c6f.svg";